module.exports = __webpack_public_path__ + "c85ba9f8a317db7e1e3f31d92e765e45.MP3";